<template>
  <div class="mt-3">
    <v-row>
      <v-col cols="6" class="d-flex flex-column">
        <v-card class="rounded-lg shadow  shadow flex d-flex flex-column">
          <v-card-title>
            Répartition des gagnants par date
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader height="300" type="table"/>
          </v-card-text>

          <v-card-text class="flex" v-else>
            <v-data-table class="table-border rounded-lg"
                          :headers="headers"
                          :items="dates"
                          :items-per-page="5"
            >
              <template v-slot:item.date="{ item }">
                <v-chip label style="background-color:rgba(34,158,217,0.15) ;color: #229ed9">
                  <v-icon color="#229ed9" size="20" left>mdi-clock-check</v-icon>
                  {{ item.date }}
                </v-chip>
              </template>

              <template v-slot:item.total_user_winning_amount="{ item }">
                <span class="text-no-wrap font-weight-bold gifty-text">
                  {{ CurrencyFormatting(item.total_user_winning_amount) }} DZD
                </span>
              </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" class="d-flex flex-column">
        <v-card class="rounded-lg shadow  shadow flex d-flex flex-column">
          <v-card-title>
            Cadeaux physiques
          </v-card-title>
          <v-divider></v-divider>

          <v-card-text v-if="isLoading">
            <v-skeleton-loader height="300" type="table"/>
          </v-card-text>

          <v-card-text class="flex" v-else>
            <v-data-table class="table-border rounded-lg"
                          :headers="headers2"
                          :items="gifts"
                          :items-per-page="5"
            >
              <template v-slot:item.image="{ item }">
                <v-avatar size="45" rounded class="my-3">
                  <v-img :src="FILE_URL + item.image"></v-img>
                </v-avatar>
              </template>

              <template v-slot:item.quantity="{ item }">
                <v-chip small style="background-color: rgba(61,34,189,0.15);color: #5635ef">
                  <v-icon color="#5635ef" size="20" left>mdi-package-variant</v-icon>
                  {{ item.quantity }}
                </v-chip>
              </template>

              <template v-slot:item.quantity_winning="{ item }">
                <v-chip small style="background-color: rgba(25,233,18,0.15);color: #19e912">
                  <v-icon color="#19e912" size="20" left>mdi-gift</v-icon>
                  {{ item.quantity_winning }}
                </v-chip>
              </template>

            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  props: ['boosting_method_id'],
  data() {
    return {
      isLoading: false,
      headers: [
        {text: 'Date', value: 'date'},
        {text: 'Gagnants', value: 'total'},
        {text: 'Gains', value: 'total_user_winning_amount'},
        {text: 'Cadeaux physiques', value: 'total_boosting_physical_gifts'},
      ],
      dates: [],

      headers2: [
        {text: 'Image', value: 'image'},
        {text: 'Cadeau', value: 'name'},
        {text: 'Quantité actuelle', value: 'quantity'},
        {text: 'Quantité gagnée', value: 'quantity_winning'},
      ],
      FILE_URL: process.env.VUE_APP_FILE_URL,
      gifts: [],
    }
  },
  methods: {
    getDailyUsage() {
      this.isLoading = true
      if (!this.boosting_method_id) return;
      HTTP.get('/v1/boosting-methods/dashboard/daily-usage', {
        params: {
          boosting_method_id: this.boosting_method_id
        }
      }).then(res => {
        this.isLoading = false
        this.dates = res.data.data.dates
        this.gifts = res.data.data.gifts
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
  },
  created() {
    this.getDailyUsage()
  },
  watch: {
    boosting_method_id(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getDailyUsage();
      }
    }
  }
}
</script>

<style scoped>

</style>